<template>
  <div>
    <v-progress-linear
      v-if="uploading"
      :value="uploadProgress"
      color="primary"
      height="4"
      striped
      reactive
      class="my-1"
    />

    <div class="d-flex align-center mt-2">
      <v-textarea
        v-model="localMessage"
        :placeholder="$t('chat.form.message.placeholder')"
        :disabled="disabled || uploading"
        :max-length="maxLength"
        filled
        rounded
        dense
        hide-details="auto"
        class="ml-3 mr-2 message-box"
        no-resize
        rows="1"
        auto-grow
        :class="{
          'message-input_empty': !localMessage,
          'message-input_content': !!localMessage,
        }"
        @keydown.enter.exact.prevent
        @keyup.enter.exact="send"
        @keydown.shift.enter.exact="newLine"
      >
        <template v-slot:append>
          <chat-file-menu
            @add-media="addMedia"
          />
        </template>
      </v-textarea>

      <v-btn
        color="primary"
        :disabled="disabled || uploading"
        class="mr-2 depressed"
        icon
        @click="send"
      >
        <v-icon>
          mdi-send-outline
        </v-icon>
      </v-btn>
    </div>

    <div
      v-if="lengthInfo"
      class="d-flex align-center justify-end mr-15"
    >
      <span class="text--darken-2 grey--text text-body-2">
        {{ lengthInfo }}
      </span>
    </div>
  </div>
</template>

<script>
import ChatFileMenu from "./../chat-file-menu.vue";

export default {
  name: "MessageComposer",

  components: {
    ChatFileMenu,
  },

  props: {
    message: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    uploading: {
      type: Boolean,
      default: false,
    },

    uploadProgress: {
      type: Number,
      default: 0,
    },

    maxLength: {
      type: Number,
      default: null,
    },

    lengthInfo: {
      type: String,
      default: "",
    },
  },

  computed: {
    localMessage: {
      get() {
        return this.message;
      },

      set(value) {
        this.$emit("update:message", value);
      },
    },
  },

  methods: {
    send() {
      this.$emit("send");
    },
    addMedia(data) {
        this.$emit('add-media', data)
    },
    newLine() {
      // Le Shift + Enter laisse le comportement
      // natif du textarea.
    },
  },
};
</script>

<style lang="scss" scoped>
.message-input {
  &_empty {
    .v-input__slot {
      .v-text-field__slot {
        align-items: center;

        textarea {
          min-height: 0 !important;
          margin-top: 6px !important;
          align-self: center;
          line-height: 2.2rem;
          margin-bottom: 6px !important;
        }
      }
    }
  }

  &_content {
    .v-input__slot {
      .v-text-field__slot {
        align-items: center;

        textarea {
          align-self: center;
          line-height: 1.5rem;
          margin-bottom: 6px !important;
          max-height: 38px !important;
          overflow-y: auto !important;
        }
      }
    }
  }
}
</style>
